import { mergeAttributes, Node } from '@tiptap/core';
import './styles.scss';

const ConclusionZone = Node.create({
  name: 'conclusionzone',
  group: 'block',
  content: 'block+',
  draggable: false,

  parseHTML() {
    return [
      {
        tag: 'div[id=conclusionzone]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { id: 'conclusionzone' }),
      0,
    ];
  },
});

export default ConclusionZone;
